var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.searchItem.web}},[_c('div',{staticClass:"searchItem clickable"},[_c('div',{staticClass:"searchItem__content"},[_c('h3',{staticClass:"searchItem__title"},[_vm._v(_vm._s(_vm.searchItem.title))]),_c('p',{staticClass:"searchItem__text"},[_vm._v(" "+_vm._s(_vm.searchItem.category)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }